import * as React from 'react'
import { cn } from '@/lib/utils'

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(
        'flex min-h-[64px] w-full rounded-md border border-slate-200 bg-white px-3 py-2 text-sm',
        'text-navy-900 placeholder:text-slate-400',
        'ring-offset-background transition-shadow duration-fluid ease-fluid',
        'hover:border-navy-200',
        'focus-visible:outline-none focus-visible:border-navy-500 focus-visible:shadow-glow',
        'disabled:cursor-not-allowed disabled:bg-slate-50 disabled:opacity-60',
        'motion-reduce:transition-none resize-y',
        className,
      )}
      {...props}
    />
  ),
)
Textarea.displayName = 'Textarea'

export { Textarea }
